/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React from 'react';
import {Table} from '@alifd/next';

const TableBox = (props) => {
  return <Table {...props}>
    <Table.Column title="日期" dataIndex="reportDate" />
    <Table.Column title="已催付订单数/笔" dataIndex="careNum" />
    <Table.Column title="已催付订单金额/元" dataIndex="careAmount" />
    <Table.Column title="挽回订单数/笔" dataIndex="payNum" />
    <Table.Column title="挽回订单金额/元" dataIndex="payAmount" />
    <Table.Column title="催付成功率" dataIndex="successRate" />
    <Table.Column title="ROI" dataIndex="roi" />
  </Table>
};

export default TableBox;
